import { Outlet } from "react-router"

export function RootTemplate() {
  return <Outlet />
}
